import { getNewPasswordSchema } from "Schemas/passwordSchema";
import { Resources, type TFunction } from "Translations/Resources";
import { z } from "zod";

export const getSetPasswordValidationSchema = (t: TFunction) =>
  z
    .object({
      password: getNewPasswordSchema(t),
      passwordRepeated: z.string().min(1, t(Resources.Validation.Required)),
    })
    .refine((data) => data.password === data.passwordRepeated, {
      message: t(Resources.Validation.Password.Match),
      path: ["passwordRepeated"],
    });

export type SetPasswordFormModel = z.infer<
  ReturnType<typeof getSetPasswordValidationSchema>
>;
